import { useCallback } from "react";
import { useTourState } from "@heroncendre/player";
import chainesJson from "./chaines.json";

type Cle = Exclude<keyof typeof chainesJson.fr, "parcours">;
type Variables = Record<string, string | number>;

/**
 * Les mots de l'interface guidée, dans la langue du visiteur (`chaines.json`) : le
 * français à défaut. `{n}`, `{total}`… sont remplacés ; `plural` choisit
 * `<clé>_one` ou `<clé>_other`.
 */
export function useChaines() {
  const language = useTourState((s) => s.context.language);
  const table = (chainesJson as Record<string, typeof chainesJson.fr>)[language] ?? chainesJson.fr;

  const t = useCallback(
    (cle: Cle, variables: Variables = {}): string => {
      const brut = (table[cle] as string | undefined) ?? (chainesJson.fr[cle] as string);
      return Object.entries(variables).reduce((texte, [nom, valeur]) => texte.split(`{${nom}}`).join(String(valeur)), brut);
    },
    [table],
  );

  const scenes = useCallback((n: number) => t(n === 1 ? "scenes_one" : "scenes_other", { n }), [t]);

  const parcours = useCallback(
    (route: string) => (table.parcours as Record<string, string>)[route] ?? route,
    [table],
  );

  return { t, scenes, parcours, language };
}
